<div class="row" *ngIf="hidden">
  <div class="col-12">
    <div class="filter-body">
      <div class="filter">
        <div class="row">
          <div class="col-11" *ngIf="!showAdvancedFilter && initApiData?.filterArray?.length">
            <div class="row" [formGroup]="FilterForm">
              <ng-container *ngFor="let item of initApiData.filterArray;let index=index">
                <ng-container *ngIf="item.showInMainFilter">
                  <div class="col" *ngIf="item.type == 'string'">
                    <input type="text" class="form-control " id="reqSender" [placeholder]="item.name"
                      [formControlName]="item.controllerName" appPreventFirstSpace>
                  </div>
                  <div class="col-2" *ngIf="item.type == 'dropdown' ">
                    <app-select-dropdown [label]="item.dropDownLabel?item.dropDownLabel:''" [placeholder]="item.name"
                      [multiple]="item.multiSelect ? item.multiSelect : false" [singleSelect]="false"
                      [isClearable]="true" [options]="item?.option" [search]="true" id="id" class="dropdown-with-status"
                      [formControlName]="item.controllerName">
                    </app-select-dropdown>
                  </div>
                  <div class="col" *ngIf="item.type == 'Date' ">
                    <app-datepicker_v2 [formControlName]="item.controllerName" [field]="feild_Date"></app-datepicker_v2>
                  </div>
                  <div class="col" *ngIf="item.type == 'checkbox'">
                    <input autocomplete="disabled" class="form-check-input" [formControlName]="item.controllerName"
                      type="checkbox" [id]="'checkBox'+index" [name]="'checkBox'+index">
                    <label class="form-check-label link" [for]="'checkBox'+index"
                      style="font-size: 11.5px;">{{item.name}}</label>
                  </div>
                </ng-container>
              </ng-container>

              <div class="col-2 d-flex">
                <button id="btnGroupApply" type="button" class="btn btn-dark-blue" (click)="appalyFilter();"
                  [ngClass]="{'disabled':FilterForm.invalid}">APPLY</button>
                <a class="reset-btn" (click)="advFilter=false;reset()"><span></span>Reset</a>
              </div>
            </div>

          </div>
          <div class="col-1" *ngIf="initApiData?.filterArray?.length">
            <a class="advanced-btn float-end" id="advanced-search" (click)="onAdvancedClick($event)">Advanced</a>
          </div>
          <!-- Advanced filter items -->
          <div class="col-12" #advancedFilter *ngIf="initApiData?.filterArray?.length">
            <div *ngIf="showAdvancedFilter" class="dropdown post-code-dropdown advanced-search">
              <div class="dropdown-menu show" aria-labelledby="post-code" (click)="onInsideAdvanceContainerClick()">

                <div class="dropdown-body">
                  <div class="row" [formGroup]="FilterForm">
                    <ng-container *ngFor="let item of initApiData.filterArray;let index=index">
                      <div class="col-2 mb-3" *ngIf="item.type !='checkbox'">
                        <input autocomplete="disabled" class="form-check-input" *ngIf="item.type =='checkbox'"
                          formControlName="isOverriden" type="checkbox" [id]="'checkBox'+index"
                          [name]="'checkBox'+index">
                        <label class="form-label" [for]="'checkBox'+index">{{item.name}}</label>
                        <input type="text" class="form-control " *ngIf="item.type == 'string'" id="reqIDAdv"
                          placeholder="" [formControlName]="item.controllerName" appPreventFirstSpace>
                        <app-datepicker_v2 *ngIf="item.type == 'Date' " [formControlName]="item.controllerName"
                          [field]="feild_Date"></app-datepicker_v2>
                        <app-select-dropdown *ngIf="item.type == 'dropdown'"
                          [label]="item.dropDownLabel?item.dropDownLabel:''" placeholder="Select"
                          [multiple]="item.multiSelect ? item.multiSelect : false" [singleSelect]="false"
                          [isClearable]="true" [options]="item?.option" [search]="true" id="id"
                          class="dropdown-with-status" [isClearable]="true" [formControlName]="item.controllerName">
                        </app-select-dropdown>
                      </div>
                      <div class="col-2 mt-4" *ngIf="item.type =='checkbox'">
                        <input autocomplete="disabled" class="form-check-input" *ngIf="item.type =='checkbox'"
                          formControlName="isOverriden" type="checkbox" [id]="'checkBox'+index"
                          [name]="'checkBox'+index">
                        <label [for]="'checkBox'+index" class="form-check-label link">{{item.name}}</label>
                      </div>
                    </ng-container>
                    <div class="col-12">
                      <hr>
                    </div>
                    <div class="col-12">
                      <div class="btn-wrap float-end">

                        <button type="button" class="btn btn-outline-secondary" id="reset-filter-btn"
                          (click)="reset()">RESET</button>
                        <button type="button" class="btn btn-primary" id="apply-filter-btn"
                          (click)="appalyFilter();advFilter=true"
                          [ngClass]="{'disabled':FilterForm.invalid}">APPLY</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="filter-wrap margin-minus" *ngIf="advFilter ">
      <ng-container *ngFor="let item of initApiData.filterArray">
        <ng-container *ngIf="!item.showInMainFilter">
          <span class="filter-item" *ngIf="FilterForm.value[item.controllerName]">
            <a> {{item.name}} : {{FilterForm.value[item.controllerName]}}
              <img src="assets/images/icons/filter-close.svg" alt="" (click)="closeAdvanceFilter(item.controllerName)">
            </a>
          </span>
        </ng-container>
      </ng-container>
    </div>

  </div>
  <div class="col-12">
    <div class="table-container table-responsive">

      <table class="table table-list" *ngIf="initApiData?.listHeader?.length">
        <caption class="d-none">Provider list table body</caption>

        <thead>
          <tr>
            <th scope="col" *ngFor="let item of initApiData.listHeader">{{item.Name}}
              <span *ngIf="item.sort" class="sort-order">
                <a class="{{columnSort[item.sortParams]?.sortType}} " (click)="sort(item.sortParams)"></a>
              </span>
            </th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dummyData;let index = index">
            <ng-container *ngFor="let itemdummy of initApiData.listHeader;let index = index">
              <td *ngIf="itemdummy?.type != 'status'">{{item[itemdummy.apiParams] | notEmpty}}</td>
              <td *ngIf="itemdummy?.type == 'status'">
                <div class="status" *ngIf="item[itemdummy.apiParams] === null"><span>-</span></div>
                <div class="status dark-red-circle-status" *ngIf="item[itemdummy.apiParams] === 0">
                  <span></span>Rejected
                </div>
                <div class="status navy-blue-circle-status" *ngIf="item[itemdummy.apiParams] === 1">
                  <span></span>Approved
                </div>
                <div class="status yellow-circle-status" *ngIf="item[itemdummy.apiParams] === 2">
                  <span></span>Partially Approved
                </div>
                <div class="status dark-red-circle-status" *ngIf="item[itemdummy.apiParams] === 3">
                  <span></span>Cancelled
                </div>
              </td>
            </ng-container>
            <td>
              <ul class="actions">
                <li (click)="navigateToView(item)">
                  <a data-bs-toggle="modal" class="view tool-wrap position-relative">
                    <div class="custom-tooltip tooltip-top" role="tooltip">
                      <div class="arrow"></div>
                      <div class="tooltip-inner"> View </div>
                    </div>
                  </a>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="inner-loader-wraper" *ngIf="fetchingInProgress">
        <div class="inner-loader"></div>
      </div>
      <div class="no-data with-border" *ngIf="!fetchingInProgress && !dummyData?.length">
        <img src="./assets/images/icons/no-data-img.svg" alt="">
        <p>No Results Found</p>
      </div>
    </div>

    <app-navigation [listLength]="totalCount" [pageNo]="page_no"
      (currentPageDetail)="currentPageDetail($event)"></app-navigation>
  </div>
</div>